<template>
    <div class="container my-4" v-if="prodnuevos.length > 0">
        <!-- Header con título y botones -->
        <SectionTitle variant="accent" accent-bar title="<strong>Productos</strong> más comprados" />
        <!-- Lista de productos -->
        <div class="row w-100 mx-0">
            <div class="col-12 px-0">
                <sliderprods :productos="prodnuevos" />
            </div>
        </div>
    </div>
</template>


<script>
//import SectionTitle from '../navegation/ComponentsRecomend/CompoentsViews/titleseccions.vue';
import SectionTitle from '../../../Complements/Components/Titleseccions.vue';
import Sliderprods from '../../../Complements/Components/Sliderprods.vue';
export default {
    name: "itemsbestbuyprods",
    components: {
        Sliderprods,
        SectionTitle
    },
    data() {
        return {
            prodnuevos: [],
            currentIndex: 0,
            visibleCount: 4
        };
    },
    computed: {
        productosVisibles() {
            return this.prodnuevos.slice(this.currentIndex, this.currentIndex + this.visibleCount);
        },
        vehiculoSeleccionado() {
            return this.$store.getters.vehiculoSeleccionado;
        }
    },
    methods: {
        async fetchData() {
            try {
                const veh = this.vehiculoSeleccionado;

                const { data } = await axios.get('/api/controllerpeticiones/prodsbannerbestbuy');
                this.prodnuevos = data.filtrado ?? [];
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        nextItem() {
            if (this.currentIndex + this.visibleCount < this.prodnuevos.length) {
                this.currentIndex++;
            }
        },
        prevItem() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
            }
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>